/**
 * Tema pagine gym - token condivisi (light + dark).
 *
 * Dark mode: superfici slate/neutrali (stile dashboard SaaS).
 * Il brand viola/indigo resta su CTA, tab attivi e focus - non su card/sfondi.
 */

// ── Dark: superfici e testo ─────────────────────────────────────────────
export const gymDarkPageBg = 'dark:bg-gray-950';

export const gymDarkHeaderBar =
  'border-b border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900';

export const gymDarkContentPadding = 'box-border max-w-full px-fluid-lg pb-fluid-lg sm:px-fluid-xl';

export const gymDarkCard = 'dark:bg-gray-900 dark:border-gray-800';

/** Righe header tabella, chip filtri inattivi, celle ora */
export const gymDarkSurface = 'dark:bg-gray-800';

export const gymDarkBorder = 'dark:border-gray-800';

export const gymDarkMutedText = 'dark:text-gray-400';

export const gymDarkBodyText = 'dark:text-gray-200';

export const gymDarkTitleText = 'dark:text-gray-50';

/** Input / select standard gym */
export const gymDarkInput =
  'dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100 dark:placeholder:text-gray-500 dark:focus:border-indigo-500 dark:focus:ring-indigo-500/30';

/** Chip / toggle filtro inattivo (es. calendario) */
export const gymDarkFilterInactive =
  'bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700';

/** Riga lista / elemento cliccabile - evita hover:bg-gray-50 senza override dark (testo illeggibile) */
export const gymDarkRowHover =
  'hover:bg-gray-50 dark:hover:bg-gray-800/70';

/** Chip / toggle filtro attivo - usa colore semantico (indigo, blue, green) sul componente */

// ── Modali ──────────────────────────────────────────────────────────────
export const gymModalPanel =
  'w-full rounded-xl border border-gray-200 bg-white shadow-xl dark:border-gray-800 dark:bg-gray-900';

export const gymModalHeader =
  'flex items-center justify-between border-b border-gray-200 p-4 dark:border-gray-800 dark:bg-gray-800/80';

export const gymModalLabel = 'mb-1 block text-sm font-medium text-gray-700 dark:text-gray-200';

export const gymModalInput =
  'w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100 dark:placeholder:text-gray-500 dark:focus:border-indigo-500 dark:focus:ring-indigo-500/30';

// ── Social / Marketing ──────────────────────────────────────────────────
export const gymSocialCard =
  'rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-800 dark:bg-gray-900';

export const gymMarketingCardInner = 'p-6 sm:p-7';

export const gymMarketingSplitGrid = 'grid grid-cols-1 xl:grid-cols-3 gap-6 w-full';

export const gymMarketingMainCol = 'xl:col-span-2 min-w-0';

export const gymMarketingSideCol = 'min-w-0 flex flex-col';

export const gymSocialTabActive =
  'rounded-lg px-4 py-2 text-sm font-medium bg-indigo-600 text-white shadow';

export const gymSocialTabInactive =
  'rounded-lg px-4 py-2 text-sm font-medium bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700';

export const gymContentTabActive =
  'rounded-lg px-4 py-2 text-sm font-medium bg-indigo-600 text-white shadow';

export const gymContentTabInactive =
  'rounded-lg px-4 py-2 text-sm font-medium border border-gray-300 bg-white text-gray-700 hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700';

export const gymSocialPageBg = 'bg-gray-50 dark:bg-gray-950';

export const gymSocialBtnPrimary =
  'inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-50';

export const gymSocialBtnSecondary =
  'inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-gray-300 bg-white text-gray-800 hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700 disabled:opacity-50';

export const gymSocialMutedText = 'text-gray-600 dark:text-gray-400';

export const gymSocialTitleText = 'text-gray-900 dark:text-gray-50';

export const gymSocialAlertWarn =
  'rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-500/40 dark:bg-amber-950/40 dark:text-amber-100';

export const gymSocialAlertError =
  'rounded-lg border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800 dark:border-red-500/40 dark:bg-red-950/40 dark:text-red-100';

export const gymSocialInsetBox =
  'rounded-lg border border-gray-200 bg-gray-50/80 dark:border-gray-800 dark:bg-gray-800/50';

export const gymSocialDetailPanel =
  'rounded-lg border border-gray-200 bg-gray-50 p-3 dark:border-gray-800 dark:bg-gray-800/60';

export const gymSocialListItem =
  'rounded-lg border border-gray-200/90 bg-white/60 dark:border-gray-800 dark:bg-gray-800/40 overflow-hidden';

export const gymSocialListItemButton =
  'w-full text-left p-3 flex items-start justify-between gap-2 hover:bg-gray-50 dark:hover:bg-gray-800/80 text-gray-500 dark:text-gray-400';

export const gymSocialListItemExpanded =
  'border-t border-gray-200 p-3 bg-gray-50/50 dark:border-gray-800 dark:bg-gray-900/50';

export const gymSocialSectionLabel =
  'uppercase tracking-wide text-[10px] mb-0.5 text-gray-500 dark:text-gray-500';

export const gymSocialBodyText = 'text-gray-800 dark:text-gray-200';

export const gymSocialListTitle = 'font-medium text-gray-900 dark:text-gray-50';

export const gymSocialControlLabel = 'text-sm text-gray-700 dark:text-gray-300';

export const gymSocialInputIcon = 'text-gray-400 dark:text-gray-500';

export const gymSocialBtnDanger =
  'text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300';

export const gymSocialStepIndex = 'text-xs text-gray-500 dark:text-gray-500';

export const gymSocialItemText = 'text-sm text-gray-800 dark:text-gray-200';

export const gymSocialLogText = 'text-xs text-gray-700 dark:text-gray-300';

export const gymSocialLogMeta = 'text-gray-400 dark:text-gray-500';

export const gymSocialLogMessage = 'text-gray-500 dark:text-gray-400';

// ── Calendario (composizioni) ───────────────────────────────────────────
export const gymCalendarShell = `bg-gray-50 ${gymDarkPageBg} h-screen flex flex-col overflow-hidden`;

export const gymCalendarCard =
  'bg-white rounded-lg shadow border border-gray-200 dark:bg-gray-900 dark:border-gray-800';

export const gymCalendarGridHeader = `bg-gray-50 ${gymDarkSurface} border-b border-gray-200 ${gymDarkBorder}`;

export const gymCalendarTodayBtn =
  'bg-indigo-100 hover:bg-indigo-200 text-indigo-700 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors dark:bg-indigo-600/25 dark:hover:bg-indigo-600/35 dark:text-indigo-300';

/** Pannello modale grande (dashboard, membri) */
export const gymModalShell =
  'relative flex flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-2xl dark:border-gray-800 dark:bg-gray-900 dark:shadow-black/35';

export const gymModalShellHeader =
  'flex shrink-0 items-center justify-between border-b border-gray-200 bg-[#dad8e5] px-4 py-3 dark:border-gray-800 dark:bg-gray-800';

export const gymModalShellBody = 'flex-1 overflow-auto bg-[#faf9fc] dark:bg-gray-900';

/** Bottone primario dark (sostituisce #382e84 su CTA) */
export const gymDarkBtnPrimary =
  'bg-blue-600 hover:bg-blue-700 text-white dark:bg-indigo-600 dark:hover:bg-indigo-700';
